import styleInject from '../../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "/*\n * Shadow / None\n * CTAs, Text, Cards\n */\n/*\n * Shadow / XS\n * No current use\n */\n/*\n * Shadow / S\n * Cards, Toasts\n */\n/*\n * Shadow / M\n * Dropdown menu options\n */\n/*\n * Shadow / L\n * Accordions\n */\n/*\n * Shadow / XL\n * No current use\n */\n/* This forwarded module is generated by Style Dictionary */\n.ContextMenuSeparator__container__7-36-1__EuecT {\n  border-bottom: 1px solid #cdd3d7;\n  display: block;\n}";
var styles = {"container":"ContextMenuSeparator__container__7-36-1__EuecT"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=ContextMenuSeparator.scss.js.map
